<script lang="ts">
	import { onMount } from 'svelte';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	import { requestEditDevice } from 'src/components/Lists/list-helpers';
	import { postReq } from 'src/services/http';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Design system components
	import { Toggle } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../types/Device';
	import { NotifType } from 'src/types/DeviceNotifPermissions';

	export let device: Device;
	let notification_permission = 'ai_device_failure';

	let loading = false;
	let disabled = false;

	const save = async (notification, type) => {
		loading = true;
		device.notif_permissions[notification][type] = device.notif_permissions[notification][type]
			? 0
			: 1;
		const res = await postReq('interface/device/set_device_notifications', {
			id: device.id,
			set: notification, // 'ai_device_failure'
			val: device.notif_permissions[notification][type], // 1 or 0 aka true or false
			ntype: type, //0 or 1 aka  NotifType.MAIL or NotifType.PUSH
		});
		loading = false;

		//0 or 1 aka  NotifType.MAIL or NotifType.PUSH
		const toastTexts =
			type === 0
				? {
						success: $format('toast_succ_exclude_ai_failure_email', {
							default: '"Failure detection" e-mails settings changed.',
						}),
						danger: $format('setting_err_toast', {
							default: 'Failed to apply settings.',
						}),
					}
				: {
						success: $format('toast_succ_exclude_ai_failure_notification', {
							default: '"Failure detection" notifications settings changed.',
						}),
						danger: $format('setting_err_toast', {
							default: 'Failed to apply settings.',
						}),
					};
		onSettingsResponse(res, device, toastTexts);
	};

	onMount(() => {
		if (
			typeof device?.notif_permissions === 'undefined' ||
			typeof device.notif_permissions[notification_permission] === 'undefined'
		) {
			// Ensure that device.notif_permissions is defined
			device.notif_permissions = device?.notif_permissions ?? {};
			// Ensure that device.notif_permissions[notification] is defined
			device.notif_permissions[notification_permission] = device?.notif_permissions?.[
				notification_permission
			] ?? [1, 1];

			requestEditDevice(device);
		}
	});

	// Used to bind the toggles to the device.notif_permissions object
	$: notifPermissionsBool =
		typeof device?.notif_permissions !== 'undefined'
			? Object.keys(device.notif_permissions)?.reduce((acc, notification) => {
					return {
						...acc,
						[notification]: {
							[NotifType.MAIL]:
								device.notif_permissions[notification][NotifType.MAIL] === 1,
							[NotifType.PUSH]:
								device.notif_permissions[notification][NotifType.PUSH] === 1,
						},
					};
				}, {})
			: {};
</script>

<!-- {#if device.category == 'relay'}
	<Alert
		class="mb-s"
		type="info"
		heading={$format('alert_exclude_ai_forgotten', {
			default:
				'You can exclude the device from the "Forgotten lights reminder" if your device is designated as a "light" in the "Appliance type" setting.'
		})}
	/>
{/if} -->

<Toggle
	class={$showNewLayout ? 'mb-s' : ''}
	{disabled}
	checked={Boolean(notifPermissionsBool?.['ai_device_failure']?.[NotifType.MAIL])}
	size="m"
	on:click={() => save('ai_device_failure', NotifType.MAIL)}
	id="toggle-dug3uqn"
>
	{$format('label_exclude_emails_ai_failure', {
		default: 'Enable "Failure detection" e-mails for this device.',
	})}
</Toggle>

<Toggle
	{disabled}
	checked={Boolean(notifPermissionsBool?.['ai_device_failure']?.[NotifType.PUSH])}
	size="m"
	on:click={() => save('ai_device_failure', NotifType.PUSH)}
	id="toggle-9do0l5k"
>
	{$format('label_exclude_notifications_ai_failure', {
		default: 'Enable "Failure detection" notifications for this device.',
	})}
</Toggle>
